import { Component } from "react";

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: "" };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, message: error?.message || String(error) };
  }

  componentDidCatch(error, info) {
    // Log local para inspeção via console. Sem envio externo.
    console.error("[ErrorBoundary]", error, info?.componentStack);
  }

  handleRetry = () => {
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div
        data-testid="error-boundary-fallback"
        className="min-h-screen bg-[#F5F1E8] flex items-center justify-center px-6"
      >
        <div className="max-w-md w-full bg-[#FFFFFF] border border-stone-200 rounded-lg p-10 text-center">
          <div className="text-[11px] uppercase tracking-[0.25em] text-[#D4A652] mb-3 font-semibold">
            Ocorreu um erro
          </div>
          <h1 className="font-serif text-2xl text-stone-900 mb-3">
            Algo deu errado nesta tela
          </h1>
          <p className="text-stone-600 text-sm mb-4">
            Tente recarregar. Se o problema persistir, avise a equipe.
          </p>
          {this.state.message && (
            <p className="text-xs text-stone-400 mb-6 break-words">
              {this.state.message}
            </p>
          )}
          <button
            onClick={this.handleRetry}
            data-testid="btn-error-retry"
            className="px-5 py-2 rounded-md bg-[#083A6B] hover:bg-[#052B50] text-white text-sm font-medium"
          >
            Tentar novamente
          </button>
        </div>
      </div>
    );
  }
}
